const getSpaceIdFromUrl = ({ pathname }) => {
  const [, spaceId] = pathname.split('/');
  return spaceId || '';
};

export default getSpaceIdFromUrl;
